import './style.css'
import { Img2PdfApp } from './apps/img2pdf.js'
import { PdfSplitApp } from './apps/pdfsplit.js'
import { Pdf2PdfApp } from './apps/pdf2pdf.js'
import { Pdf2ImgApp } from './apps/pdf2img.js'
import { PdfCompressApp } from './apps/pdfcompress.js'

class PDFToolsApp {
  constructor() {
    this.currentApp = null;
    this.apps = {
      img2pdf: new Img2PdfApp(),
      pdfsplit: new PdfSplitApp(),
      pdf2pdf: new Pdf2PdfApp(),
      pdf2img: new Pdf2ImgApp(),
      pdfcompress: new PdfCompressApp()
    };
    
    this.init();
  }

  init() {
    // Add event listeners
    this.setupEventListeners();
    
    // Show main menu by default
    this.showMainMenu();
  }

  setupEventListeners() {
    // Tool card clicks
    document.querySelectorAll('.tool-card').forEach(card => {
      card.addEventListener('click', (e) => {
        const appName = card.dataset.app;
        if (this.apps[appName]) {
          this.showApp(appName);
        }
      });
    });

    // Back button
    document.getElementById('back-button').addEventListener('click', () => {
      this.showMainMenu();
    });
  }

  showMainMenu() {
    // Hide any current app
    if (this.currentApp) {
      this.currentApp.destroy();
      this.currentApp = null;
    }

    // Show main menu, hide app container
    document.getElementById('main-menu').style.display = 'block';
    document.getElementById('app-container').style.display = 'none';
  }

  showApp(appName) {
    if (!this.apps[appName]) {
      console.error(`App ${appName} not found`);
      return;
    }

    // Hide main menu, show app container
    document.getElementById('main-menu').style.display = 'none';
    document.getElementById('app-container').style.display = 'block';

    // Set app title
    const titles = {
      img2pdf: '🖼️ Images to PDF Converter',
      pdf2pdf: '📄 PDF Merger',
      pdfsplit: '✂️ PDF Splitter',
      pdf2img: '🖼️ PDF to Images',
      pdfcompress: '🗜️ PDF Compressor'
    };
    
    document.getElementById('app-title').textContent = titles[appName] || appName;

    // Initialize and show the app
    this.currentApp = this.apps[appName];
    this.currentApp.init(document.getElementById('app-content'));
  }
}

// Initialize the app when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new PDFToolsApp();
});